@if (legendData.length) {
<f-legend class="mb-1 body-30" [data]="legendData" [alignment]="'horizontal'" [contentAlignment]="'end'"></f-legend>
}
<f-stacked-bar
  [data]="data"
  [thickness]="thickness"
  [animation]="animation"
  [animationDelay]="animationDelay"
  [animationDuration]="animationDuration"
  [popoverTemplate]="popoverTemplate"
  [popoverTriggers]="popoverTriggers"
  [popoverPlacement]="popoverPlacement"
  [containerClass]="containerClass"
  [barSegmentTemplate]="segmentTpl"
></f-stacked-bar>

<ng-template #segmentTpl let-item>
  @if (inlineLabelPercentages.has(item)) {
  <span class="bar-segment-label">{{ item }}%</span>
  }
</ng-template>

@if (belowBarLabelData.length) {
<div class="f-stacked-bar-labels body-50">
  @for (item of belowBarLabelData; track item) {
  <div class="bar-segment-label-slot">
    <span class="bar-segment-label bar-segment-label-below"> {{ item.label }} - {{ item.percentage }}% </span>
  </div>
  }
</div>
}
